<!-- <h1 mat-dialog-title *ngIf="MoreDetails">Clear Search History</h1> -->
<h1 mat-dialog-title>Clear Search History</h1>
<div mat-dialog-content>
  <p>Are you sure you want to clear all entries in the search history?</p>
</div>
<div mat-dialong-actions>
  <button
    role="button"
    type="button"
    aria-label="Yes"
    mat-button
    cdkFocusInitial
    (click)="dialogRef.close('yes')"
  >
    Yes
  </button>
  <button role="button" type="button" aria-label="No" mat-button (click)="dialogRef.close('no')">
    No
  </button>
</div>
